import {
    Column,
    PinboardSourceColumn,
    PinboardSourceDetail,
    SourceDetail,
} from '../generated/graphql-types';

type CommonSourceDetailType = SourceDetail | PinboardSourceDetail;
type CommonSourceColumnType = Column | PinboardSourceColumn;

// Sort columns by name for each data source
const sortByObjName = (
    objA: CommonSourceDetailType | CommonSourceColumnType,
    objB: CommonSourceDetailType | CommonSourceColumnType,
) => {
    const nameA = objA.name.toLowerCase();
    const nameB = objB.name.toLowerCase();
    return nameA > nameB ? 1 : -1;
};

export const excludeCohortColumns = (sourceDetails: SourceDetail[]) => {
    return [...sourceDetails].map(source => {
        if (!source?.columns?.length) {
            return source;
        }
        const sortedColumns = [...source.columns].filter(
            column => !column.cohortType,
        );
        return {
            ...source,
            columns: sortedColumns,
        };
    });
};

export const sortSourceDetails = (sourceDetails: CommonSourceDetailType[]) => {
    if (!sourceDetails) {
        return undefined;
    }
    return [...sourceDetails]?.sort(sortByObjName).map(source => {
        if (!source?.columns?.length) {
            return source;
        }
        const sortedColumns = [...source.columns].sort(sortByObjName);
        return {
            ...source,
            columns: sortedColumns,
        };
    });
};
